import router from '../router';

export default {
  generateFullPath(routeData) {
    const path = router.resolve(routeData).href;

    return window.location.origin + path;
  },
};
